/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_AddressInputs */

const en_email_address = /** @type {(inputs: Email_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address`)
};

const es_email_address = /** @type {(inputs: Email_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico`)
};

const fr_email_address = /** @type {(inputs: Email_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse e-mail`)
};

const de_email_address = /** @type {(inputs: Email_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse`)
};

const ja_email_address = /** @type {(inputs: Email_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレス`)
};

const zh_email_address = /** @type {(inputs: Email_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮箱地址`)
};

const ar_email_address = /** @type {(inputs: Email_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عنوان البريد الإلكتروني`)
};

const id_email_address = /** @type {(inputs: Email_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat email`)
};

const it_email_address = /** @type {(inputs: Email_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indirizzo e-mail`)
};

const ru_email_address = /** @type {(inputs: Email_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Электронная почта`)
};

const pt_email_address = /** @type {(inputs: Email_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endereço de e-mail`)
};

const ko_email_address = /** @type {(inputs: Email_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 주소`)
};

/**
* | output |
* | --- |
* | "Email address" |
*
* @param {Email_AddressInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const email_address = /** @type {((inputs?: Email_AddressInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_AddressInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_email_address(inputs)
	if (locale === "es") return es_email_address(inputs)
	if (locale === "fr") return fr_email_address(inputs)
	if (locale === "de") return de_email_address(inputs)
	if (locale === "ja") return ja_email_address(inputs)
	if (locale === "zh") return zh_email_address(inputs)
	if (locale === "ar") return ar_email_address(inputs)
	if (locale === "id") return id_email_address(inputs)
	if (locale === "it") return it_email_address(inputs)
	if (locale === "ru") return ru_email_address(inputs)
	if (locale === "pt") return pt_email_address(inputs)
	return ko_email_address(inputs)
});